import { render, staticRenderFns } from "./CenterCmp.vue?vue&type=template&id=302fbebe&"
import script from "./CenterCmp.vue?vue&type=script&lang=ts&"
export * from "./CenterCmp.vue?vue&type=script&lang=ts&"
import style0 from "./CenterCmp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports